import axios from "axios";
import helper from "../utils/helper";

var AdminServicesAxios = axios.create({
   baseURL: process.env.VUE_APP_API_AS_BASE_URL
});

AdminServicesAxios.baseURL = process.env.VUE_APP_API_AS_BASE_URL;
AdminServicesAxios.interceptors.request.use(function (config) {
  config.withCredentials = true;
  let userToken = null
  if(window.viewBag && window.viewBag.user) {
    userToken = window.viewBag.user.token;
  }
  if(!userToken) {
    userToken = helper.findGetParameter('i2e1-admin-token')
  }
  config.headers.common['Content-Type'] ='application/json;charset=utf-8';
  config.headers.common['i2e1-admin-token'] = userToken;
  config.headers.common['i2e1-admin-view-token'] = userToken; 
  return config;
});

AdminServicesAxios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.log(error);
    
  }
);

export default AdminServicesAxios;
